import { formatCurrency } from "@/helpers/formatCurrency.ts";
import { PaymentProviderEnum } from "@/helpers/types/types.ts";
import { PaymentNoteProps } from "@/pages/ReservationOverview/components/PaymentNote/PaymentNoteProps.ts";
import { useRenderCheckReservationOverviewSubmit } from "@/pages/ReservationOverview/components/ReservationOverviewSubmit/hooks/useRenderCheckReservationOverviewSubmit.ts";
import { getAPIUrl } from "@/stores/ApolloClient/helpers/getAPIUrl.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { Trans } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

export const PaymentNote = (props: PaymentNoteProps) => {
  const { paymentEnabled, paymentType } = props;
  const { calculatedCartData, isForcedInquiry } = useEngineStore(
    useShallow((state) => ({
      calculatedCartData: state.calculatedCartData,
      isForcedInquiry: state.calculatedCartData?.isForcedInquiry,
    })),
  );
  const { hasAccTypesForPaymentInCart, hasAccTypeCategoriesForPaymentInCart } =
    useRenderCheckReservationOverviewSubmit();

  const shouldShowNote = paymentEnabled && !isForcedInquiry;

  if (shouldShowNote && paymentType === PaymentProviderEnum.WsPay) {
    const isDownPaymentDifferentThanTotal =
      !!calculatedCartData?.downPaymentAmount &&
      !!calculatedCartData?.priceBreakdown?.withDiscount &&
      calculatedCartData?.downPaymentAmount !== calculatedCartData?.priceBreakdown?.withDiscount;

    if (isDownPaymentDifferentThanTotal) {
      return (
        <>
          <p>
            <Trans
              i18nKey={
                hasAccTypesForPaymentInCart || hasAccTypeCategoriesForPaymentInCart
                  ? "cardPaymentValueOptionalInNextStep"
                  : "cardPaymentValueInNextStep"
              }
              components={{ b: <strong /> }}
              values={{ amount: formatCurrency(calculatedCartData.downPaymentAmount) }}
            />
          </p>
          <p>
            <Trans i18nKey="remainingPayAmountInfo" />
          </p>
        </>
      );
    }

    return (
      <p>
        <Trans i18nKey="cardPaymentInNextStep" />
      </p>
    );
  }
  if ((shouldShowNote && getAPIUrl().includes("materra")) || getAPIUrl().includes("staging")) {
    return (
      <p>
        <Trans i18nKey="paymentNote" components={{ 1: <br /> }} />
      </p>
    );
  }

  return null;
};
